export default __webpack_public_path__ + "static/media/2gis.0a79b6e4.png";